/**
 * Merge two point lists, deduped by `t` and returned sorted ascending by `t`.
 *
 * On a duplicate `t`, `incoming` wins. This is correct for immutable historical
 * points (the two copies are identical) and for a fresher fetch of the trailing
 * edge overwriting an older one. It is also where the trailing-edge last-write-wins
 * behavior lives — a stale fetch landing after a fresh one would regress the trailing
 * point, which in-flight dedup / abort must prevent.
 */
export function mergePoints<T extends { t: number }>(existing: T[], incoming: T[]): T[] {
    const byTime = new Map<number, T>();

    existing.forEach((point) => {
        byTime.set(point.t, point);
    });

    incoming.forEach((point) => {
        byTime.set(point.t, point);
    });

    return Array.from(byTime.values()).sort((a, b) => a.t - b.t);
}
